import { useFormContext } from 'react-hook-form';

import { VARIANTS } from 'shared';

import { ModalButton } from 'shared/components/Modal/ModalButton';

type TGoalAddDialogFooter = {
  onSubmit: () => void;
};

export const GoalAddDialogFooter = ({ onSubmit }: TGoalAddDialogFooter) => {
  const { formState } = useFormContext();

  return (
    <>
      <ModalButton variant="outline">Cancel</ModalButton>
      <ModalButton
        color={VARIANTS.PRIMARY}
        onClick={onSubmit}
        shouldClose={formState.isValid}
        dataTestid="goal-done-btn"
      >
        Save
      </ModalButton>
    </>
  );
};
